export default {
    methods: {
        async onAddOrRemoveSubordinate (subordinate) {
            switch (this.shareWatchListActiveTab) {
            case 1:
                await this.$store.dispatch('Watchlists/shareWatchListAddOrRemoveSubordinate', subordinate)
                this.setSelectAllFlag()
                break
            case 2:
                await this.$store.dispatch('Watchlists/shareWatchListAddOrRemoveMember', subordinate)
                this.setSelectAllFlag()
                break
            }
        },
        setSelectAllFlag () {
            if (this.subordinates.every(subordinate => this.selectedSubordinates.find(selectedSubordinate => selectedSubordinate === subordinate))) {
                this.selectAllUsers = true
            } else {
                this.selectAllUsers = false
            }
        },
        async addAllSubordinates () {
            switch (this.shareWatchListActiveTab) {
            case 1:
                this.selectAllUsers = !this.selectAllUsers
                if (this.selectAllUsers) {
                    await this.$store.dispatch('Watchlists/shareWatchListAddAllSubordinates', this.subordinates)
                } else {
                    await this.$store.dispatch('Watchlists/shareWatchListAddAllSubordinates', [])
                }
                break
            case 2:
                this.selectAllUsers = !this.selectAllUsers
                if (this.selectAllUsers) {
                    await this.$store.dispatch('Watchlists/shareWatchListAddAllMembers', this.subordinates)
                } else {
                    await this.$store.dispatch('Watchlists/shareWatchListAddAllMembers', [])
                }
                break
            }
        },
        addSubordinate () {
            this.$emit('addSubordinate', this.subordinate)
        }
    },
    computed: {
        getSubordinatesBySelectedTab () {
            return this.shareWatchListActiveTab === 1 ? this.selectedSubordinates : this.selectedMembers
        },
        isSharedSubordinatesList () {
            return this.shareWatchListActiveTab === 2
        },
        getSubordinateState () {
            if (!this.shared) {
                return this.$t('WatchListModal.share_watchlist_tabs_not_shared')
            } else {
                return this.$t('WatchListModal.share_watchlist_tabs_shared')
            }
        },
        isSubordinateSelected () {
            if (this.selectedSubordinates === undefined) {
                return false
            }
            return this.selectedSubordinates.filter(selectedSubordinate => selectedSubordinate.userId === this.subordinate.userId).length > 0
        },
        isSelectedWatchListSharedToAllSubordinates () {
            if (this.selectedWatchList === undefined) {
                return false
            }
            return this.selectedWatchList.mode === 0
        },
        isSelectedWatchListSharedToSelectedUsers () {
            if (this.selectedWatchList === undefined) {
                return false
            }
            return this.selectedWatchList.mode === 1
        }
    }
}
